(ns storrito.connect3.verify-panel
  (:require [storrito.ui.button :as button]
            [storrito.connect3.common :as common]
            [clojure.string :as str]
            ))

(defn input-validation
  [digits-count event]
  ;; You could also register a corresponding data-driven
  ;; event-handler into the global one, but using inline
  ;; code for plain input validation feels more pragmatic:
  (set! event.target.value
        (-> event.target.value
            (subs 0 digits-count)
            (str/replace #"[^0-9]" ""))))

(defn- on
  [state digits-count]
  {:change [[:store/assoc-in [:connect3 :twofacode] :event/target.value]
            [:connect3/validate-twofacode]]
   :input (partial input-validation
                   digits-count)
   :keyup [[:js/on-enter]
           [:connect3/send! (select-keys state
                                         [:twofacode])]]
   })

(defn panel
  [state]
  (let [username (:username state)
        step-data (:step_data state)
        contact-point (:contact_point step-data)]
    [:div.flex.items-center.justify-center
     [:div.bg-white.shadow-xl.rounded-2xl.px-8.pt-10.pb-10.max-w-xl.w-full.mx-auto.flex.flex-col.items-center
      (common/instagram-logo)
      [:div.text-center.mb-5
       [:h2.font-bold.text-xl.text-center
        [:span "Instagram has sent a verification code to the following telephone number/email address:"]]
       [:h2.font-bold.text-2xl.text-center contact-point]]
      [:p.text-lg.text-gray-700.mb-6.text-center.w-full
       (if username
         [:span [:b username]]
         nil)]
      [:div.flex.flex-col.justify-center.items-center.w-full
       ;; Wrapper div for password-manager compatibility, see comment in
       ;; `storrito.connect3.login-panel/panel`.
       [:div
        [:input#twofacode.px-5.py-3.placeholder-gray-500.border-gray-400.rounded-md.border-2.text-center.text-2xl.tracking-widest.bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-blue-500.focus:border-blue-500.transition-all.duration-200.mb-4
         {:style {:width "200px"}
          :name "code"
          :type "text"
          :required true
          :placeholder "- - - - - -"
          :on (on state 6)
          :autoFocus true}]]
       (common/error-message state)
       (button/button-primary-lg
         {:class "w-full mt-4"
          :on {:click (when (:twofacode-valid state)
                        [[:connect3/send! (select-keys state [:twofacode])]])}}
         "Submit")]]]))
